import GujaratiDay from "../../data/gujaratiDay.json";
export const GujaratiDays = (paramsObj) => {
  return GujaratiDay;
};
